import { Deserializable } from '../../deserializable';

export class PlaceholderUploadSettings implements Deserializable {
  public MaxNumberOfUploadedDocuments: number;
  public NumberOfUploadedFiles: number;
  public MaxFileSizeInBytes: number;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
